import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostCsvExcelAccountsRequestModel, PostCsvExcelAccountsResponseModel } from "@/features/accounts/csv-excel/services/post-accounts-model";

export class PostCsvExcelAccountsApi {
  /**
   * CsvExcel登録API
   */
  public postCsvExcelAccounts = async (
    param: PostCsvExcelAccountsRequestModel
  ): Promise<PostCsvExcelAccountsResponseModel> => {
    const path = `/api/csvexcelaccounts`;
    const res = await ApiClient.instance.post<PostCsvExcelAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
